import { FC } from 'react';
import { Filter } from 'src/api/types';
import NextImage from 'src/shared-components/NextImage/NextImage';
import { GeneratedLinkUrlObject, SearchPageQueryType } from 'src/utils/links';

const cross = 'shared/small-close.svg';

interface Props {
  filter: Filter;
  pageLinkGenerationMethod: (
    query: SearchPageQueryType
  ) => GeneratedLinkUrlObject;
  removeFilter: (filter: Filter) => void;
}

const FilterCard: FC<Props> = ({ filter, removeFilter }) => {
  return (
    <button
      onClick={() => removeFilter(filter)}
      className="flex items-center my-1.5 mr-1 px-1.5 py-0.5 border border-astronautBlue rounded-md"
    >
      <p className="fs-caption-reg text-astronautBlue pr-2">{filter.name}</p>
      <NextImage
        alt="delete"
        src={cross}
        layout="fixed"
        height={10}
        width={10}
      />
    </button>
  );
};

export default FilterCard;
